export const ORG_MEMBERSHIP_ACCESS_OWNER_TYPE = 'OrganizationMembership'
export const EXT_EMAIL_ACCESS_OWNER_TYPE = 'DomainControlExternalEmail'
export const EXT_LINK_ACCESS_OWNER_TYPE = 'DomainControlExternalLink'

export const RADIO_BUTTON_NAME = 'accessOwnerType'
export const INPUT_COMPONENT_NAME = 'accessOwnerValue'
